import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-term-services',
  templateUrl: './term-services.component.html',
  styles: [],
})
export class TermServicesComponent implements OnInit {
  constructor(private modal: NgbModal) {}

  ngOnInit(): void {}
  close = () => this.modal.dismissAll();
}
